import axios from "axios";
import { API } from "../config";

const path = "/servico-acolhimento";

class RegularidadeSAService {
  novaRegularidadeSA(id, regularidadeSA) {
    let formData = new FormData();


    for (let key in regularidadeSA) {
      if (!(key.includes("anexo") && regularidadeSA[key] === null)) {
        formData.append(key, regularidadeSA[key]);
      }
    }

    return axios.post(API + path + `/${id}/regularidade`, formData);
  }

  getRegularidadeSA(id) {
    return axios.get(API + path + `/${id}/regularidade`)
  }

  atualizarRegularidadeSA(id, regularidadeSA) {
    let formData = new FormData();

    for (let key in regularidadeSA) {
      if (!(key.includes("anexo") && regularidadeSA[key] === null)) {
        formData.append(key, regularidadeSA[key]);
      }
    }

    return axios.put(API + path + `/${id}/regularidade`, formData);
  }
}

const instanceRegularidadeSA = new RegularidadeSAService();
export default instanceRegularidadeSA;